export default "__VITE_ASSET__axT1mnRb__"